import React from 'react';
import styled from 'styled-components';
import HistoryIcon from '@mui/icons-material/History';

interface NoJobsOverlayProps {
	title?: string;
	subtitle?: string;
}

export function NoJobsOverlay({
	title = 'No jobs for this object',
	subtitle = 'Use + to start a service on this object.',
}: NoJobsOverlayProps) {
	return (
		<Wrapper>
			<Box>
				<HistoryIcon />
				<Title>{title}</Title>
				<Subtitle>{subtitle}</Subtitle>
			</Box>
		</Wrapper>
	);
}

const Wrapper = styled('div')({
	height: '100%',
});

const Box = styled('div')(({ theme }) => ({
	alignItems: 'center',
	border: `1px dashed ${theme.palette.light.backgroundAlt}`,
	borderRadius: '8px',
	display: 'flex',
	flexDirection: 'column',
	gap: theme.spacing(1),
	height: '100%',
	justifyContent: 'center',
	padding: theme.spacing(3),
	textAlign: 'center',

	'& svg': {
		color: theme.palette.text.secondary,
		fontSize: '38px',
	},
}));

const Title = styled('div')(({ theme }) => ({
	color: theme.palette.text.primary,
	fontSize: theme.typography.s2Regular.fontSize,
}));

const Subtitle = styled('div')(({ theme }) => ({
    color: theme.palette.text.secondary,
    fontSize: theme.typography.bodySmallRegular.fontSize,
    lineHeight: 1.5,
    maxWidth: '340px',
}));